import moment from "moment";
var CommonMixins = {
  methods: {
    genrateSrNo(i) {
      var sr = i + 1;
      return 30 * this.page_no + sr;
    },
    formatCurrency(value) {
      let rupeeIndian = Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
      });
      return rupeeIndian.format(value);
    },
    maskEmail(email) {
      const [localPart, domain] = email.split("@");
      if (!localPart || !domain) {
        return email; // Return the email as is if it's not in a valid format
      }
      const firstLetter = localPart.slice(0, 1);
      const maskedSection = ".".repeat(localPart.length - 1);
      return `${firstLetter}${maskedSection}@${domain}`;
    },
    maskMobileNumber(number) {
      if (number.length < 4) {
        return number; // Return the number as is if it's too short to mask
      }
      const firstTwo = number.slice(0, 2);
      const lastTwo = number.slice(-2);
      const maskedSection = "x".repeat(number.length - 4);
      return `${firstTwo}${maskedSection}${lastTwo}`;
    },
    format_datemonthstamp(value) {
      if (value) {
        var localTime = new Date(value * 1000).toUTCString();
        return moment(localTime).format("DD/MM/YYYY");
      } else {
        return moment().format("DD/MM/YYYY");
      }
    },
    format_timestamp(value) {
      if (value) {
        return moment(value).format("DD/MM/YYYY");
      } else {
        return moment().format("DD/MM/YYYY");
      }
    },
    format_datetime(value) {
        if (value) {
            var localTime = new Date(value * 1000).toUTCString();
            return moment(localTime).format("DD/MM/YYYY @ hh:mm A");
        } else {
            return 'N/A';
        }
    },
    format_datetime_stamp(value) {
        if (value) {
            return moment.unix(value).utc().format("DD/MM/YYYY @ hh:mm A");
        } else {
            return 'N/A';
        }
    },

    format_timeonlystamp(value) {
      if (value) {
        var localTime = new Date(value * 1000).toUTCString();
        return moment(localTime).format("hh:mm a");
      } else {
        return moment().format("hh:mm a");
      }
    },
    calculateDaysDifference(value) {
      if (value) {
        let createdDate = new Date(value * 1000);
        let currentDate = new Date(); // Get the current date
        let differenceInTime = currentDate - createdDate; // Difference in milliseconds
        let differenceInDays = Math.floor(
          differenceInTime / (1000 * 60 * 60 * 24)
        ); // Convert to days
        return differenceInDays + " days ago";
      } else {
        return "N/A";
      }
    },
    maskedNumber(getvalue) {
      const maskedDigits = "X".repeat(getvalue.length - 6);
      const FirstThreeDigits = getvalue.slice(0, 3);
      const lastThreeDigits = getvalue.slice(-3);
      return FirstThreeDigits + maskedDigits + lastThreeDigits;
    },
    isLetterWithOutSpace(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z]+$/.test(char)) return true;
      else e.preventDefault();
    },
     onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }
    },
    isLetterWithSpace(e) {
      let charspace = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z\s]+$/.test(charspace)) return true;
      else e.preventDefault();
    },
  },
};
export default CommonMixins;
